<mat-expansion-panel class="connection-help">
  <mat-expansion-panel-header>
    <mat-panel-title>How to connect {{ guide.platform }}</mat-panel-title>
  </mat-expansion-panel-header>

  <div class="guide-content">
    <section>
      <h3>Before you start</h3>
      <ul>@for (item of guide.before; track item) {<li>{{ item }}</li>}</ul>
    </section>

    <section>
      <h3>Connect in Shine</h3>
      @if (guide.method === 'oauth2') {
        @if (editing) {
          <p>Select <strong>Re-authenticate</strong> to sign in again. Complete the provider tab and return to Shine.</p>
        } @else {
          <p>Enter a connection name, keep <strong>OAuth 2.0</strong> selected and click <strong>Authenticate</strong>.
            Complete the provider tab; Shine saves the connection when authorization succeeds.</p>
        }
      } @else {
        @if (editing) {
          <p>Leave Key value blank to keep the stored key. To replace it, enter the new key and click <strong>Save</strong>.
            After replacing the key, verify the selected accounts again in Sources.</p>
        } @else {
          <p>Choose <strong>API key</strong>, follow the platform steps below, enter the credential in <strong>Key value</strong>
            and click <strong>Create connection</strong>.</p>
        }
      }
      <ol>@for (step of guide.steps; track step) {<li>{{ step }}</li>}</ol>
    </section>

    <section>
      <h3>Verify account access</h3>
      <p>Open <strong>Shine Performance → Overview → Sources</strong>. Select <strong>Choose accounts</strong>,
        select only the intended advertisers and click <strong>Verify and save</strong>.
        Link an existing reporting client when available. Account selection and reporting-client mapping are separate steps.</p>
      @if (guide.verificationNote) {<p>{{ guide.verificationNote }}</p>}
      <p>Data collection and invoicing are set up separately.</p>
    </section>

    <section>
      <h3>If you get stuck</h3>
      <ul>@for (item of guide.troubleshooting; track item) {<li>{{ item }}</li>}</ul>
    </section>

    <nav class="guide-links" aria-label="Official platform documentation">
      @for (doc of guide.docs; track doc.url) {
        <a [href]="doc.url" target="_blank" rel="noopener noreferrer">{{ doc.label }} (opens in a new tab)</a>
      }
    </nav>
  </div>
</mat-expansion-panel>
